<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 20px;
      display: flex;
    "
  >
    <div
      style="
        flex: 1.5;
        border-radius: 10px;
        box-shadow: 0 0 5px 1px #e2e2e2;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      "
    >
      <ul
        style="
          border-bottom: 1px solid #e2e2e2;
          font-weight: 600;
          font-size: 13px;
          margin: 0 20px;
          padding: 20px 0;
        "
      >
        待办事项
      </ul>
      <div style="flex: 1; padding: 0 20px 20px 20px; overflow-y: auto">
        <div
          style="
            border-bottom: 1px solid #e2e2e2;
            padding-bottom: 15px;
            padding: 15px;
            cursor: pointer;
          "
          class="notice-ul"
          v-for="item in state.todoData"
          :key="item"
          @click="
            $store.commit('openMenu', {
              path: 'SalaryApplyDetail',
              title: '发薪单审核',
              refresh: true,
              data: {
                id: item.table_id,
              },
            })
          "
        >
          <ul style="display: flex; align-items: center">
            <li style="font-size: 15px; font-weight: 600">{{ item.type }}</li>
            <li style="margin-left: 10px; color: #a2a2a2; font-size: 13px">
              {{ item.table_order_id }}
            </li>
          </ul>
          <ul
            style="
              display: flex;
              align-items: center;
              font-size: 15px;
              margin-top: 5px;
            "
          >
            <li style="flex: 1">{{ item.title }}</li>
            <text style="color: #a2a2a2; font-size: 13px">
              {{ $dayjs(item.create_time).format("YYYY-MM-DD") }}
            </text>
          </ul>
        </div>
        <c_page
          v-if="state.todoTotal > 20"
          :total="state.todoTotal"
          :pageIndex="state.todoParams.page"
          @onLoad="
            (pageIndex) => {
              state.todoParams.page = pageIndex;
              onLoadToDo();
            }
          "
        />
      </div>
    </div>
    <div
      style="flex: 1; display: flex; flex-direction: column; margin-left: 20px"
    >
      <div
        style="
          border-radius: 10px;
          box-shadow: 0 0 5px 1px #e2e2e2;
          display: flex;
          padding: 20px;
          cursor: pointer;
        "
        @click="
          $store.commit('openMenu', {
            path: 'HomeEditInfo',
            title: '个人信息',
            refresh: true,
          })
        "
      >
        <div
          style="
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #3399ff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            color: #fff;
          "
        >
          {{ $store.state.loginUser?.name }}
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <ul style="font-size: 13px; font-weight: 600">
            {{
              $store.state.loginUser?.name + "，早上好"
            }}
          </ul>
          <ul
            v-if="$store.state.loginUser?.department_name"
            style="margin-top: 8px; color: #a2a2a2; font-size: 13px"
          >
            {{
              $store.state.loginUser?.department_name
            }}
          </ul>
        </div>
      </div>
      <div
        style="
          flex: 1;
          border-radius: 10px;
          box-shadow: 0 0 5px 1px #e2e2e2;
          margin-top: 20px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        "
      >
        <ul
          style="
            border-bottom: 1px solid #e2e2e2;
            font-weight: 600;
            font-size: 13px;
            margin: 0 20px;
            padding: 20px 0;
          "
        >
          通知公告
        </ul>
        <div style="overflow-y: auto; flex: 1; padding: 0 20px 20px 20px">
          <ul
            style="
              display: flex;
              line-height: 70px;
              border-bottom: 1px solid #e2e2e2;
              cursor: pointer;
            "
            class="notice-ul"
            v-for="item in state.noticeData"
            :key="item"
            @click="
              state.noticeModel = item;
              state.showNotice = true;
            "
          >
            <li style="flex: 1; font-weight: 600; font-size: 14px">
              {{ item.title }}
            </li>
            <li style="font-size: 13px; color: #a2a2a2">
              {{ $dayjs(item.create_time).format("YYYY-MM-DD") }}
            </li>
          </ul>
          <c_page
            v-if="state.noticeTotal > 20"
            :total="state.noticeTotal"
            :pageIndex="state.noticeParams.page"
            @onLoad="
              (pageIndex) => {
                state.noticeParams.page = pageIndex;
                onLoadNotice();
              }
            "
          />
        </div>
      </div>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showNotice"
      :title="state.noticeModel.title"
      @close="state.showNotice = false"
    >
      <c_AdminNoticeDetail
        @close="state.showNotice = false"
        :id="state.noticeModel.id"
      ></c_AdminNoticeDetail>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { home_todolist, home_noticelist } from "@/http/api";
export default {
  setup() {
    const state = reactive({
      todoParams: {
        limit: 0,
        page: 1,
        status: 0,
      },
      noticeParams: {
        limit: 0,
        page: 1,
      },
    });
    onMounted(() => {
      onLoadToDo();
      onLoadNotice();
    });

    const onLoadToDo = () => {
      home_todolist(state.todoParams).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.todoData = list;
          state.todoTotal = count;
        }
      });
    };

    const onLoadNotice = () => {
      home_noticelist().then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.noticeData = list;
          state.noticeTotal = count;
        }
      });
    };
    return { state, onLoadToDo, onLoadNotice };
  },
};
</script>
<style scoped lang="less">
.notice-ul {
  &:hover {
    border-bottom: 2px solid #e2e2e2 !important;
  }
}
</style>
